import { action, observable } from 'mobx';

import { FunctionModel } from '@app/Models';
import ApiService from '@app/Services/ApiService';
import { ApiUrls } from '@app/AppConstants';

export default class FunctionStore {
    @observable functionList: FunctionModel[] = [];

    constructor(){
        void this.loadFunctions();
    }
    
    @action
    async loadFunctions() {
        const { data } = await ApiService.getTypedData<FunctionModel[]>(ApiUrls.FunctionUrl);
        this.functionList = data;
    }
}
